import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import { forwardRef } from "react";
import { Box, Button, ButtonProps, Paper } from "@mui/material";
import {
  Check as CheckIcon,
  WarningAmber as WarningAmberIcon,
} from "@mui/icons-material";
import { Flex } from "~/components/Flex";
import { Link as RouterLink } from "react-router-dom";
import { ClampWithTooltip } from "../ClampWithTooltip/ClampWithTooltip";

interface ReportCompleteProps extends CustomContentProps {
  button?: {
    label: string;
    href?: string;
    onClick?: ButtonProps["onClick"];
  };
}

export const Snackbar = forwardRef<HTMLDivElement, ReportCompleteProps>(
  (props, ref) => {
    const { id, message, variant, button, ...other } = props;
    const { closeSnackbar } = useSnackbar();

    const getIcon = () => {
      switch (variant) {
        case "success":
          return (
            <CheckIcon sx={{ color: (theme) => theme.palette.none.main }} />
          );
        case "error":
          return <WarningAmberIcon color="error" />;
      }
    };

    return (
      <SnackbarContent ref={ref} role="alert" {...other}>
        <Paper sx={{ py: 1.5, px: 2, maxWidth: "600px" }}>
          <Flex alignItems="center">
            <Flex gap={2} alignItems="center" mr={5}>
              {getIcon()}
              <ClampWithTooltip>{message}</ClampWithTooltip>
            </Flex>
            {button && (
              <Box sx={{ flex: "1 0 auto" }}>
                <Button
                  component={button.href ? RouterLink : Button}
                  {...(button.href
                    ? { to: button.href, target: "_blank", rel: "noopener" }
                    : {})}
                  {...(button.onClick ? { onClick: button.onClick } : {})}
                  sx={{
                    py: 0,
                    px: 2,
                    color: (theme) => theme.palette.primary.light,
                  }}
                  variant="text"
                >
                  {button.label}
                </Button>
              </Box>
            )}
            <Button
              onClick={() => {
                closeSnackbar(id);
              }}
              sx={{ py: 0, px: 2 }}
            >
              CLOSE
            </Button>
          </Flex>
        </Paper>
      </SnackbarContent>
    );
  },
);
